type Ease = [number, number, number, number]

const easeValues = {
  in: [0.55, 0.06, 0.68, 0.19] as Ease,
  out: [0.22, 0.61, 0.36, 1] as Ease,
  inOut: [0.46, 0.03, 0.52, 0.96] as Ease,
}

export const theme = {
  colors: {
    background: '#fff',
    text: '#14130F',
    accent: {
      primary: '#ffb400',
      primaryLight: '#FFD05F',
      secondary: '#0065CA',
      secondaryLight: '#0097FF',
    },
  },
  fonts: {
    base: '"Manrope", sans-serif',
    headings: '"Manrope", sans-serif',
  },
  easeValues,
  ease: Object.keys(easeValues).reduce(
    (acc, key) => ({
      ...acc,
      [key]: `cubic-bezier(${easeValues[key as keyof typeof easeValues].join(
        ', '
      )})`,
    }),
    { in: '', out: '', inOut: '' }
  ),
}
